import Matrix from '@mc/matrix-main'
import MatrixBaseParamsPlugin from '@mc/matrix-base-params-plugin'
import { Bridge } from '@mc/mc-jsbridge'

const matrix = new Matrix({
  debug: process.env.NODE_ENV === 'development',
  BridgeContext: Bridge,
  plugins: [new MatrixBaseParamsPlugin()]
})

window.matrix = matrix

matrix.init().then(() => {
  require('./vue-init')
})
